/**
 * A job whose every document type was removed takes no new work (ADR-0096, owner 2026-10-30): files stay untouched in
 * its watched folder and queued pages are not read, since there is no type to file a document by. Adding a type
 * starts it again. The job card and Export › Activity say so in these words.
 */
export const NO_TYPE_LEFT_SENTENCE = 'Add a document type to start processing again.';

/** Whether a refusal (as it arrives over IPC, behind Electron's prefix) is reading refused for that reason: a wait. */
export const isNoTypeLeftRefusal = (message: string): boolean =>
  message.endsWith(NO_TYPE_LEFT_SENTENCE);

/** Whether a set-up job has no type left to file documents by (an archived type files nothing new). */
export const hasNoTypeLeft = (job: {
  status?: string;
  documentTypes: ReadonlyArray<{ status?: string }>;
}): boolean =>
  job.status !== 'provisional' && job.documentTypes.every((type) => type.status === 'archived');
